import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // В мобилке было false: там свежесть догонялась через pull-to-refresh,
      // которого в вебе нет. Возврат на вкладку — естественная замена жесту.
      refetchOnWindowFocus: true,
      retry: 1,
      staleTime: 30_000,
    },
    mutations: {
      retry: 0,
    },
  },
})

export const qk = {
  me: ['me'] as const,
  billing: ['billing'] as const,
  billingStatus: ['billing', 'status'] as const,
  billingUsage: ['billing', 'usage'] as const,
  billingPlans: ['billing', 'plans'] as const,
  billingProducts: ['billing', 'products'] as const,
  payments: ['billing', 'payments'] as const,
  payment: (id: string) => ['billing', 'payments', id] as const,
  limits: ['limits'] as const,
  verseOfDay: ['verseOfDay'] as const,
  streak: ['streak'] as const,
  readingPosition: ['readingPosition'] as const,
  conversations: (params?: { limit?: number; cursor?: string | null }) =>
    ['conversations', params?.limit ?? 20, params?.cursor ?? null] as const,
  conversation: (id: string) => ['conversation', id] as const,
  messages: (conversationId: string, params?: { limit?: number; offset?: number }) =>
    ['messages', conversationId, params?.limit ?? 50, params?.offset ?? 0] as const,
  bibleTranslations: ['bible', 'translations'] as const,
  bibleBooks: (translation: string) => ['bible', 'books', translation] as const,
  bibleChapter: (translation: string, book: string, chapter: number) =>
    ['bible', 'chapter', translation, book, chapter] as const,
  bibleSearch: (q: string, translation: string) => ['bibleSearch', q, translation] as const,
  notes: ['notes'] as const,
  notesList: (limit = 20, offset = 0) => ['notes', 'list', limit, offset] as const,
  noteDetail: (id: string) => ['notes', 'detail', id] as const,
  groupChat: (id: string) => ['groupChat', id] as const,
  userSearch: (email: string) => ['userSearch', email] as const,
}
